module.exports = __webpack_public_path__ + "img/acertemos.ce87a19.jpg";